<template>
  <div
    v-loading="loading"
    element-loading-text="考核云正在拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <!-- <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype">组件模式：{{ groupmode }}</div>
      <div class="testtype">命题方式：{{ unified }}</div>
    </div> -->
    <div class="baic_content">
      <!-- 权重的表格 -->
      <div class="hos_table" v-if="groupmode === '权重组卷'">
        <el-form :v-model="getData">
          <el-table
            :model="getData"
            :data="getData"
            style="width: 100%"
            :summary-method="getSummaries"
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px'
            }"
          >
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="StyleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  :readonly="true"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  @blur="refn(scope.row)"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="Explain" label="题型说明" width="430px">
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="reduce">
          <p>合计：</p>
          <div>
            <p>{{ weightreducefen }}分</p>
            <p>{{ weightreducesum }}题</p>
          </div>
        </div>
      </div>
      <!-- 表单内容 -->
      <div class="hos_table" v-else>
        <el-form :v-model="getData">
          <el-table
            :model="getData"
            :data="getData"
            style="width: 100%"
            :summary-method="getSummaries"
            show-summary
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px'
            }"
          >
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="StyleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  maxlength="10"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Total" label="题数"> </el-table-column>
            <el-table-column prop="Score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  @change="checkscore(scope.row.Score, scope.$index)"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="TestCount" label="题量">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.TestCount"
                  class="small_input"
                  @change="checkscore(scope.row, scope.$index, 'test')"
                ></el-input
                >题
              </template>
            </el-table-column>
            <el-table-column prop="Explain" label="题型说明" width="430px">
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="previousstep()">上一步</el-button>
        <el-button
          type="success"
          class="submit_btn"
          @click="nexttothree"
          :loading="isrelease"
          >确定</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
  </div>
</template>

<script>
import getappstyle from "@/api/questionbank";
import { getTestStyle } from "@/api/examination.js";
import loginvuex from "@/store/index";
import qs from "qs";
//import { Loading } from 'element-ui';
export default {
  props: ["cutcoms"],
  data() {
    return {
      weightreducesum: 0, //权重总题数，
      weightreducefen: 0, //权重总分数
      textarea: "",
      input: "",
      readonly: true,
      loading: true,
      getData: [],
      reducesum: "", //总分
      reducetishi: "", //总题数
      addPaperData: [], // id
      addPaperLenght: [], // 题型
      groupmode: "", //组卷模式
      unified: "", //统一命题
      valueArr: [], //试卷组卷拼接参数
      isrelease: false //按钮加载防抖。
    };
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    checkscore(Score, indexs, istest) {
      // 2024/3/20 产品要求题数输入0时删除该数据
      if(Score.TestCount == 0){
        this.getData.splice(indexs, 1)
      }
      if (istest == "test") {
        if (isNaN(Number(Score.TestCount))) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: "请输入正确的题量值",
            type: "error"
          });
        } else if (Number(Score.TestCount) > Score.Total) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: `题量不能大于该题型${Score.StyleName}的总题量:${Score.Total}`,
            type: "error"
          });
        }
        return;
      }
      //检查分数范围。
      if (isNaN(Number(Score))) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "请输入正确的分数值",
          type: "error"
        });
      } else if (Number(Score) > 99) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "分数不能大于99",
          type: "error"
        });
      }
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = []; //循环数组加算的数字
      let value3 = []; //这里是分数的数组
      let value4 = []; //这里是题数的数组
      let reducesum = [];
      let news = [];
      let newstishu = "";
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "合计";
          return;
        }
        const value = data.map(item => Number(item[column.property]));
        if (index === 3) {
          value3 = JSON.stringify(value);
          value3 = JSON.parse(value3);
          // value3 = value;
        } else if (index === 4) {
          value4 = JSON.stringify(value);
          value4 = JSON.parse(value4);
          reducesum = value3.map((ztiem, zindex) => {
            return ztiem * value4[zindex];
          });
          news = reducesum.reduce((total, num) => {
            return Number(total) + Number(num);
          }, 0);
          newstishu = value4.reduce((totals, nums) => {
            return Number(totals) + Number(nums);
          }, 0);
          this.reducesum = news;
          this.$parent.reducesum = news;
          sums[index - 1] = news;
          sums[index - 1] += "分";
          sums[index] = newstishu;
          this.reducetishi = newstishu;
          sums[index] += "题";
        }
      });
      return sums;
    },
    // 上移
    onmoveup(index, row) {
      var that = this;
      console.log("上移", index, row);
      console.log(that.getData[index]);
      if (index > 0) {
        let upDate = that.getData[index - 1];
        that.getData.splice(index - 1, 1);
        that.getData.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    onmovedown(index, row) {
      var that = this;
      console.log("下移", index, row);
      if (index + 1 === that.getData.length) {
        alert("已经是最后一条，不可下移");
      } else {
        console.log(index);
        let downDate = that.getData[index + 1];
        that.getData.splice(index + 1, 1);
        that.getData.splice(index, 0, downDate);
      }
    },
    previousstep() {
      this.cutcoms(1);
      // console.log(this.$parent.testmode);
      // if (this.$parent.testmode === "智能组卷") {
      //   this.cutcoms(1);
      // } else if (this.$parent.testmode === "试卷组卷") {
      //   this.cutcoms(1.1);
      // } else if (this.$parent.testmode === "精准组卷") {
      //   this.cutcoms(1.2);
      // } else if (this.$parent.testmode === "权重组卷") {
      //   this.cutcoms(1.3);
      // }
    },
    destory() {
      this.$destroy();
    },
    // 智能组卷第二页获取系统分类历史
    async getDateList(quest) {
      let params = {
        config: `${quest}`,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID
      };
      const Data = await getappstyle.getappstyle(params);
      if (Data.status == 200) {
        //  this.loading = false;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = Data.data.Data;
      } else {
        this.$message.error("数据获取不到");
      }
    },
    refn(res) {
      let reg = /^[1-9]\d*$/;
      if (!reg.test(Number(res.Score))) {
        this.$message({
          message: "只能输入正整数",
          type: "warning"
        });
        res.Score = 1;
        return;
      }
      //权重输入框修改后的更改。
      console.log(res.StyleName);
      console.log(this.$parent.$children[2]);
      //这里的逻辑：1拿到题的类型，遍历styleAllArr里面的源数据进行更改。用this.$parent获取直接修改
      //2修改后，重新执行一次pagethressrefn方法,拿到计算后的总分和总题数。
      //再覆盖一次。      this.weightreducesum = this.$parent.pageStyelArr[0]['weightreducesum']
      this.$parent.$children[2].styleAllArr.map(item => {
        item.children.map(zitem => {
          if (zitem.StyleName == res.StyleName) {
            zitem.Score = res.Score;
          }
        });
      });
      this.$parent.$children[2].pagethressrefn();
      this.weightreducesum = this.$parent.pageStyelArr[0]["weightreducesum"];
      this.weightreducefen = this.$parent.pageStyelArr[0]["weightreducefen"];
    },
    nexttothree() {
      let pagethree = [
        // 智能组卷传递的参数
        {
          Score: this.reducesum,
          Total: this.reducetishi,
          ShowCount: -1
        }
      ];
      let PaperStyleID = [];
      this.getData.map(item => {
        if (item.PaperStyleID instanceof Array) {
          PaperStyleID = PaperStyleID.concat(item.PaperStyleID);
        } else if (item.PaperStyleID instanceof String) {
          PaperStyleID.push(item.PaperStyleID);
        }
      });
      pagethree.push(this.getData);
      this.createpaperres(pagethree);
      this.isrelease = true;
    },
    async createpaperres(styledata) {
      let parmas = {
        SelectedApp: this.$parent.pagetworeq1,
        SelectCpt: Object.values(this.$parent.pagetwodata).flat(2),
        Style: styledata,
        CookieApp: this.$parent.pagetworeq3,
        CookieCpt: this.$parent.pagetwodata,
        ExamType: 2,
        softApp: this.$parent.softAppdata
      };
      let resdata = {
        config: JSON.stringify(parmas),
        examMode: "paper",
        paperName: this.$parent.papaername,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid)
      };
      let res = await getappstyle.createPaper_test(qs.stringify(resdata));
      if (res.data.Status == 200) {
        this.$message.success("添加成功！");
        this.$parent.back("success");
      } else {
        this.$message({
          message: res.data.Data,
          type: "warning"
        });
        this.isrelease = false
      }
    },
    //删除操作
    deletes(index) {
      this.$confirm("确认删除当前题型吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.getData.splice(index, 1);
          if (this.getData.length < 1) {
            this.cutcoms(1);
          }
        })
        .catch(() => {});
    },
    getpaperstlye() {
      let questdata = JSON.stringify(this.$parent.pagetwodata);
      this.getDateList(questdata);
    }
  },
  activated() {
    this.getpaperstlye();
  }
};
</script>

<style lang="scss" scoped>
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 4px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 100px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.small_input {
  width: 60px !important;
  height: 32px !important;
  font-size: 15px !important;
  margin-right: 10px;
}
.super_input {
  width: 78px !important;
  height: 32px !important;
  font-size: 15px !important;
  > ::v-deep .el-input__inner {
    padding: 0px 8px !important;
    text-align: center;
  }
}
.long_input {
  width: 420px;
  height: 100%;
}
::v-deep .el-input > .el-input__inner {
  height: 32px !important;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(7) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
::v-deep .has-gutter {
  height: 70px;
  tr > td {
    background-color: #f5faff;
  }

  .cell {
    text-align: center;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
.reduce {
  height: 80px;
  background-color: #b7dcff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  p:nth-child(1) {
    margin-left: 30px;
  }
  div {
    display: flex;
    height: 80px;
    line-height: 80px;
    p {
      text-align: center;
      &:nth-child(1) {
        width: 60px;
      }
      &:nth-child(2) {
        width: 120px;
      }
    }
  }
}
</style>
